import { Howl, Howler } from 'howler';

class Player {
  constructor(url, vol = 0.5) {
    this.audio = new Howl({
      src: [url],
      html5: true,
      volume: vol,
    });

    this.url = url;
  }

  setLoop(loop) {
    this.audio.loop(loop);
  }

  play(loop = false, volume = 0) {
    if (!this.audio.playing()) {
      if (loop) {
        this.setLoop(loop);
      }

      if (volume) {
        this.audio.volume(volume);
      }

      this.audio.play();
    }
  }

  setVolume(vol = 1) {
    this.audio.volume(vol);
  }

  pause() {
    this.audio.pause();
  }

  stop() {
    this.audio.stop();
  }

  stopAll() {
    Howler.stop();
  }

  fade(from = 0, to = 1, duration = 1000) {
    this.audio.fade(from, to, duration);
  }

  getUrl() {
    return this.url;
  }
}

export default Player;
